"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftSvg = exports.LeftImage = exports.FloatingCardTitleImage = exports.FloatingCardTitle = exports.StyledTextImage = exports.StyledText = exports.StyledTextContainer = exports.FloatingCardImage = exports.FloatingCard = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.FloatingCard = native_1.default.View `
  width: 100%;
  align-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 36px 0px 27px;
  border: 6px solid red;
  border-left-color: ${({ theme }) => theme.color.primary};
  border-left-width: 5px;
  border-radius: 10px;
  border-color: ${({ theme }) => theme.lightGrey};
  border-width: 1px;
  background-color: 'rgba(255, 255, 255, 0.95)';
  shadow-color: #000000;
  shadow-offset: 0 0;
  shadow-opacity: 0.11;
  shadow-radius: 7px;
  elevation: 11;
`;
exports.FloatingCardImage = native_1.default(exports.FloatingCard) `
  flex-direction: row;
  padding: 2px 18px;
`;
exports.StyledTextContainer = native_1.default.View `
  text-align: left;
  padding: 0 18px;
  flex-grow: 1;
  flex: 1;
`;
exports.StyledText = native_1.default.Text `
  color: ${({ textColor }) => textColor || 'black'};
  text-align: center;
  font-size: 14px;
  line-height: 19px;
`;
exports.StyledTextImage = native_1.default(exports.StyledText) `
  text-align: left;
`;
exports.FloatingCardTitle = native_1.default(exports.StyledText) `
  font-size: 18px;
  margin-bottom: 10px;
`;
exports.FloatingCardTitleImage = native_1.default(exports.FloatingCardTitle) `
  text-align: left;
`;
exports.LeftImage = native_1.default.Image `
  max-width: 100px;
  height: 100px;
  justify-content: center;
`;
exports.LeftSvg = native_1.default.View `
  max-width: 100px;
  height: 100px;
  justify-content: center;
`;
